/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';
import { Tooltip } from 'react-tooltip';

import { currencyFormatDecimals } from 'constants/formats';

type BeneficiaryAsideActualVestedSectionProps = {
  currentVestedDate: string;
  currentVestedValue: number;
  currentNetFDVestedValue: number;
};

const BeneficiaryAsideActualVestedSection: FC<
  BeneficiaryAsideActualVestedSectionProps
> = ({ currentVestedDate, currentNetFDVestedValue }) => {
  const { t } = useTranslate();

  const showNestedValue = (value: number): number => {
    if (!value) return 0;
    if (value < 0) return 0;
    return value;
  };

  return (
    <div className="card-inner">
      <div className="overline-title-alt mb-2 text-center">
        {t('ActualVestedValue')}
      </div>

      <div className="profile-balance">
        <div className="profile-balance-group">
          <div className="profile-balance-sub mx-auto">
            <div className="profile-balance-amount">
              <div
                className="number text-teal d-flex justify-content-center align-items-start"
                style={{ textAlign: 'center' }}
              >
                <NumberFormat
                  value={showNestedValue(currentNetFDVestedValue)}
                  displayType="text"
                  {...currencyFormatDecimals}
                />

                <em
                  className="icon ni ni-info notification-icon ml-1 text-primary"
                  data-tooltip-id="icon-actual-vested-value-message"
                />
              </div>
            </div>

            <Tooltip
              id="icon-actual-vested-value-message"
              place="bottom"
              style={{ maxWidth: '300px', zIndex: 99 }}
            >
              {t('ActualVestedValueDetails')}
            </Tooltip>

            <div className="profile-balance-subtitle text-center">
              {t('VestedValueAt')} {currentVestedDate} {t('VestedValueDetails')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiaryAsideActualVestedSection;
